import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { EnumDescriptor } from '../../enum-descriptor';
import { ServiceEntrySheetState } from 'src/app/proxy/service-entry-sheets';
@Component({
  selector: 'app-service-entry-sheet-state-dropdown',
  templateUrl: './service-entry-sheet-state-dropdown.componente.html',
  standalone: false,
})
export class ServiceEntrySheetStateDropdownComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() serviceConfigurationState: ServiceEntrySheetState;
  @Input() allOption = false
  @Output()
  changeServiceConfigurationState = new EventEmitter<ServiceEntrySheetState | undefined>();

  serviceConfigurationStates: EnumDescriptor[];

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadServiceConfigurationState();
    this.onSelected();
  }

  loadServiceConfigurationState(): void {
    this.serviceConfigurationStates = this.getEnumOptions(ServiceEntrySheetState, this.allOption);
  }

  onSelected(): void {
    this.changeServiceConfigurationState.emit(this.serviceConfigurationState);
  }

  setSelectedState(state?: ServiceEntrySheetState): void {
    this.serviceConfigurationState = state;
    this.onSelected();
  }
}
